import moment from 'moment';

export const getFieldsFromDateAsFormatCustom = date => {
  const dobObj = moment(date);
  return {
    dd: dobObj.format('DD'),
    month3Val: dobObj.format('MMM'),
    day: dobObj.format('ddd'),
    time: dobObj.format('hh:mmA')
  };
};

export const getEDDFormat = date => {
  const edd = moment(date).format('YYYYMMDD');
  if (edd === 'Invalid date') return '';
  return edd;
};
